import { PATH } from '@/shared/constants';

export const SERVICE_LIST = [
  {
    icon: 'yozmIT_symbol',
    name: '요즘IT',
    href: 'https://yozm.wishket.com',
  },
  {
    icon: 'wishket_symbol',
    name: '위시켓',
    href: 'https://www.wishket.com',
  },
];

export const MAIN_NAV_ITEMS = [
  {
    href: PATH.LIST_NEW,
    label: '새로 나온',
    isNew: true,
  },
  {
    href: PATH.LIST_POPULAR,
    label: '인기',
  },
  {
    href: PATH.AUTHORS,
    label: '요즘 작가들',
  },
  {
    href: PATH.COLLECTION,
    label: '컬렉션',
    isNew: true,
  },
  {
    href: PATH.QUESTIONS,
    label: '물어봐',
    hasAiLabel: true,
  },
];
